import React from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import * as moment from "moment";

export default function TimePicker({
  onChange,
  value = "",
  format = "HH:mm:ss",
  name = "",
  placeholder = "Select time",
  readOnly = false,
  ...rest
}) {
  const handleTimeChange = (time) => {
    const formattedTime = time ? moment(time).format(format) : null;
    if (onChange) {
      if (typeof onChange === 'function' && onChange.length > 1) {
        onChange(name, formattedTime);
      } else {
        onChange({ target: { name, value: formattedTime } });
      }
    }
  };

  const selectedTime = value ? moment(value, format).toDate() : null;

  return (
    <DatePicker
      selected={selectedTime}
      onChange={handleTimeChange}
      showTimeSelect
      showTimeSelectOnly
      timeIntervals={15}
      timeCaption="Time"
      dateFormat="h:mm aa"
      timeFormat="h:mm aa"
      placeholderText={placeholder}
      readOnly={readOnly}
      className="form-control"
      {...rest}
    />
  );
}